<template>
    <div class="back_to_index" @click="goToIndex">
        <iconList />
    </div>
</template>

<script>
export default {
    name: 'TopbarGoPositionsList',
    components: {},
    methods:{
        goToIndex(){
            this.$router.push('/positions')
        }
    }
}
</script>

<style lang="scss">

.back_to_index{
    display: flex;
    justify-content: center;
    align-items: center;
    svg{
        padding-top: 4px;
        width: 25px;
        fill: $grey-light;
    }
}

</style>